import React, { FC } from 'react';
import BodyTopBlock, { ActionType } from 'src/components/BodyTopBlock';
import { getAdminTopBlockParams } from './functions';

const TopBlock: FC<{ actions?: ActionType[] }> = (props) => {
    const params = getAdminTopBlockParams();

    return (
        <BodyTopBlock
            tabs={params.tabs}
            selectTab={params.selected}
            onChangeTab={params.handleChange}
            actions={props.actions}
        />
    );
};

export default TopBlock;
